import { render, staticRenderFns } from "./MarketNewsFlash.vue?vue&type=template&id=446f24ed&scoped=true"
import script from "./MarketNewsFlash.vue?vue&type=script&lang=js"
export * from "./MarketNewsFlash.vue?vue&type=script&lang=js"
import style0 from "./MarketNewsFlash.vue?vue&type=style&index=0&id=446f24ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446f24ed",
  null
  
)

export default component.exports